import React, { useEffect } from 'react';
import {
  useSelector,
  useDispatch,
} from 'react-redux';
import {
  Link as RouterLink,
} from 'react-router-dom';
import * as LbIcon from 'components/Icons';
import { useLocation } from 'react-router-dom';
import {
  matchRoutes,
} from 'react-router-config';
import {
  FormattedMessage,
} from 'react-intl';
import clsx from 'clsx';
import { 
  makeStyles, 
  createStyles, 
  Theme ,
  withStyles,
  useTheme,
  createTheme,
  ThemeProvider
} from '@material-ui/core/styles';
import {
  Breadcrumbs,
  Typography,
  Icon,
  Box,
} from '@material-ui/core';
import _ from 'lodash'
import BasicTheme from 'themes'; 


const LbIcons:any = LbIcon;

export interface BreadcrumbProps {
  configName?:string;
  themeName?:string;
  options?: BreadcrumbOptions;
  previewTheme?: Theme;
  routes:any;
}

export interface BreadcrumbOptions {
  
}


const useStyles = makeStyles((theme: Theme) => createStyles({
  breadcrumbItem: {
    display: 'inline-flex',
    alignContent: 'center',
  }
}))

const Breadcrumb = (props: BreadcrumbProps) => {
  const {configName, themeName, options, previewTheme} = props;
  const componentConfig = require(`./${configName || 'config'}.json`);
  const componentTheme = require(`./${themeName || 'theme'}.json`);

  const classes = useStyles();
  const enableIcon = componentConfig.enableIcon;
  const store  = useSelector((state: any) => state);
  const location = useLocation();
  
  const defaultTheme = createTheme(_.defaultsDeep(componentTheme,BasicTheme))

  const theme:any = createTheme(_.defaultsDeep({
    overrides: {
     
    }
  }, previewTheme || defaultTheme));

  const matchedRoutes = matchRoutes(props.routes, location.pathname);

  const storeBreadcrumbName = (key: string) => {
    const storePath = key.split('.');
    let breadcrumbName: any = store;

    storePath.map((value) => {
      breadcrumbName = breadcrumbName[value] || '';
    });

    return breadcrumbName
  }
  
  const ParentRouteIcon = () => {
    const matchPath = location.pathname;
    const routes = props.routes;
   
    const matchIconName =  routes.map((parentRoute: any) => matchPath.includes(parentRoute.path[0]) ? parentRoute : false).filter((item: any) => item)[0].icon || 'help_outline';
    const MatchIconComponent = LbIcons[matchIconName] && React.createElement(LbIcons[matchIconName], {htmlColor: theme.overrides.MuiDrawer.paper.color, fontSize: 'small'}) || <Box fontSize={18} color={theme.overrides.MuiDrawer.paper.color}><Icon fontSize="inherit" className={clsx({
      'material-icons-outlined': !!matchIconName.match('outline')
    })}>{matchIconName}</Icon></Box>;

    return MatchIconComponent
  }

  return (
    <ThemeProvider<Theme> theme={theme}>
      <Breadcrumbs>
        {
          matchedRoutes.map((item: any, index: number) => {
            const route: any = item.route;
            const match: any = item.match;

            if(route.breadcrumb !== false) {
              return matchedRoutes.length -1 === index || route.breadcrumbLink === false ?
              <Typography className={clsx(classes.breadcrumbItem)} variant="body2" key={index}>
                { index === 0 && enableIcon &&
                  <Box mr={1}><ParentRouteIcon /></Box>
                }
                {route.breadcrumbName ? route.breadcrumbName && storeBreadcrumbName(route.breadcrumbName) || '-' : <FormattedMessage id={route.title} />}
              </Typography> :
              <RouterLink className={clsx(classes.breadcrumbItem)} key={index} to={ match.url || '/'}>
                { index === 0 && enableIcon &&
                  <Box mr={1}><ParentRouteIcon /></Box>
                }
                <FormattedMessage id={route.breadcrumbName && storeBreadcrumbName(route.breadcrumbName) || route.title || '-'} />
              </RouterLink>
            }
          })
        }
      </Breadcrumbs>
    </ThemeProvider>
  )
}

export default Breadcrumb;